import "../layouts/default";
import { initRatingForm } from "Functions/rating";
import { initAnchors } from "Functions/anchor";

import "Ui/slider";
import "Ui/tabs";
import "Ui/toggle";
import "Ui/star-rating";

import "Components/modal/modal-watchdog";

import "Common/wishlist";
import "Common/lightgallery";

import { Vue, i18n } from "Common/vue";
import Ratings from "VueComponents/Ratings.vue";

initRatingForm();
initAnchors();

if (window.location.hash.startsWith('#new-rating')) {
    document.addEventListener('DOMContentLoaded', () => {
        const hashQuery = window.location.hash.split('?')[1] ?? '';
        const params = new URLSearchParams(hashQuery);

        setTimeout(() => {
            $('#new-rating').on('show.bs.modal', () => {
                const customerName = params.get('customer-name');
                const customerEmail = params.get('customer-email');

                if (customerName) {
                    $('#new-rating [name="customer_name"]').val(customerName);
                }
                if (customerEmail) {
                    $('#new-rating [name="customer_email"]').val(customerEmail);
                }
            }).modal('show');
        }, 0);
    });
}

// Accessories dropdown
$(document).ready(function () {
    const $select = $("#accessory-select"); // The <r-toggle> element
    const $dropdown = $("#accessory-dropdown"); // The <r-toggle> element
    const $tabsElement = document.getElementById("accessories-tabs"); // The <r-tabs> element
    const $textElement = $select.find(".sc-text"); // The text element to update

    if (!$select.length || !$tabsElement || !$textElement.length) return;

    // Sync the dropdown text with the active tab
    $tabsElement.addEventListener("rTab.after.openTab", (event) => {
        const activeTabId = event.detail.activeTabs ? event.detail.activeTabs[0] : null;
        if (activeTabId) {
            const $activeItem = $(`.c-product-accessories__trigger[data-tab-id=${activeTabId}]`);
            if ($activeItem.length) {
                $textElement.text($activeItem.text().trim());

                // Close the dropdown
                if ($dropdown.hasClass("is-active")) {
                    $dropdown.removeClass("is-active");
                }
            }
        }
    });
});

// ratings
if (document.querySelector(".js-ratings-box")) {
    window.$_ratings = new Vue({
        i18n,
        render: (h) => h(Ratings),
    }).$mount(".js-ratings-box");

    document.querySelectorAll(".js-trigger-rating-filter").forEach((trigger) => {
        trigger.addEventListener("click", (event) => {
            const starsNumber = trigger.dataset.starsNumber;
            const ratingsCount = trigger.dataset.ratingsCount;

            rEvent.dispatch("Rating.triggerFilter", starsNumber, ratingsCount);
        });
    });
}

// floating header
$(document).ready(function () {
    function checkHeaderVisibility() {
        const scrollPosition = $(window).scrollTop(); // Get the current scroll position

        if (scrollPosition > 182) {
            $(".js-floating-header").slideDown(100); // Show the header if scrolled more than 182px
        } else {
            $(".js-floating-header").slideUp(100); // Hide the header if scrolled less than 182px
        }
    }

    // Check the visibility on page load
    checkHeaderVisibility();

    // Check the visibility during scrolling
    $(window).on("scroll", function () {
        checkHeaderVisibility();
    });
});
